/*
 * Copyright 2002-2015 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {SpelNode} from './SpelNode';

/**
 * Expression language AST node that represents null.
 *
 * @author Andy Clement
 * @author Ben March
 * @since 0.2.0
 */

function createNode(value, position) {
    var node = SpelNode.create('null', position);

    node.getValue = function () {
        return null;
    };

    return node;
}

export var NullLiteral =  {
    create: createNode
};
